module.exports = __webpack_public_path__ + "static/media/mpwtlogo.63df0151.png";